/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
import {
    mdiViewDashboard,
    mdiFileDocument,
    mdiCog,
	mdiAccountGroup,
	mdiNotebookEdit,
	mdiComment,
	mdiAccountMultiplePlus,
	mdiFileMultiple,
	mdiCalendar
} from '@mdi/js'
import CryptoJS from 'crypto-js'

let roleExamples = []

// Master
const Master = {
	label: 'Master',
	subLabel: 'Submenus Master',
	icon: mdiCog,
	menu: [
		{
			to: '/doc-category',
			label: 'Document Category',
			icon: mdiNotebookEdit,
			updateMark: true
		}
	]
}

// Human Capital
const HumanCapital = {
	label: 'Human Capital',
	subLabel: 'Submenus Human Capital',
	icon: mdiAccountGroup,
	menu: []
}
	// Programme
	const Programme = {
		to: '/programme',
		label: 'Programme Document',
		icon: mdiFileDocument,
		updateMark: true
	}
	// Training
	const Training = {
		to: '/training',
		label: 'Training Document',
		icon: mdiFileDocument,
		updateMark: true
	}
// End

// Academic
const Academic = {
	label: 'Academic',
	subLabel: 'Submenus Academic',
	icon: mdiAccountGroup,
	menu: []
}
	// Candidate
	const Candidate = {
		to: '/candidate',
		label: 'Candidate Document',
		icon: mdiFileDocument,
		updateMark: true
	}
	// Student
	const Student = {
		to: '/student',
		label: 'Students Document',
		icon: mdiFileDocument,
		updateMark: true
	}
	// Alumni
	const Alumni = {
		to: '/alumni',
		label: 'Alumni Document',
		icon: mdiFileDocument,
		updateMark: true
	}
	// MassUpload
	const MassUpload = {
		to: '/upload',
		label: 'Mass Upload',
		icon: mdiFileDocument,
		updateMark: true
	}
	// EmployeeUpload
	const EmployeeUpload = {
		to: '/employee',
		label: 'Employee Upload',
		icon: mdiFileDocument,
		updateMark: true
	}
// End

// Comboard
const Comboard = {
	label: 'Comboard',
	subLabel: 'Submenus Comboard News',
	icon: mdiComment,
	menu: [
		{
			to: '/comboard',
			label: 'Comboard Document',
			icon: mdiFileDocument,
			updateMark: true
		}
	]
}

// Registration
const Registration = {
	label: 'Registration',
	subLabel: 'Submenus Registration News',
	icon: mdiAccountMultiplePlus,
	menu: [
		{
			to: '/registration',
			label: 'Registration Document',
			icon: mdiFileDocument,
			updateMark: true
		}
	]
}

// Web
const Web = {
	label: 'Website',
	subLabel: 'Submenus event and news',
	icon: mdiCalendar,
	menu: [
		{
			to: '/event',
			label: 'Event Document',
			icon: mdiFileDocument,
			updateMark: true
		},
		{
			to: '/news',
			label: 'News Document',
			icon: mdiFileDocument,
			updateMark: true
		}
	]
}

// Administration
const Administration = {
	label: 'Administration',
	subLabel: 'Submenus Administration',
	icon: mdiFileMultiple,
	menu: [
		{
			to: '/administration',
			label: 'Project Administration',
			icon: mdiFileDocument,
			updateMark: true
		}
	]
}

let aca = 0
let cmb = 0
let rgs = 0
let wbs = 0
let adm = 0
let hrd = 0
if (localStorage.getItem('docmag')) {
	aca = 1
	cmb = 1
	rgs = 1
	wbs = 1
	adm = 1
	hrd = 1
}

// Master
roleExamples.push(Master)

// Academic
if (aca > 0) {
	HumanCapital.menu.push(Programme)
	HumanCapital.menu.push(Training)
	roleExamples.push(HumanCapital)
}
// Academic
if (aca > 0) {
	Academic.menu.push(Candidate)
	Academic.menu.push(Student)
	Academic.menu.push(Alumni)
	Academic.menu.push(MassUpload)
	Academic.menu.push(EmployeeUpload)
	roleExamples.push(Academic)
}
// Comboard
if (cmb > 0) {
	roleExamples.push(Comboard)
}
// Registration
if (rgs > 0) {
	roleExamples.push(Registration)
}
// Web
if (wbs > 0) {
	roleExamples.push(Web)
}
// Administration
if (adm > 0) {
	roleExamples.push(Administration)
}

// Role
if (localStorage.getItem('role')) {
	const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
	if (decryptedMessage === 'ROLE_ADMIN' || decryptedMessage === 'ROLE_ADMIN_ACADEMIC') {
		roleExamples = []
		roleExamples.push(Master)
		if (aca > 0) {
			roleExamples.push(Academic)
		}
	} else if (decryptedMessage === 'ROLE_TEACHER') {
		Academic.menu = []
		Academic.menu.push(Student)
		Academic.menu.push(Alumni)

		roleExamples = []
		roleExamples.push(Master)
		if (aca > 0) {
			roleExamples.push(Academic)
		}
	} else if (decryptedMessage === 'ROLE_ADMIN_WEBSITE') {
		roleExamples = []
		roleExamples.push(Master)
		if (wbs > 0) {
			roleExamples.push(Web)
		}
	} else if (decryptedMessage === 'ROLE_PROJECT_MANAGER' || decryptedMessage === 'ROLE_PROJECT_SECRETARY') {
		roleExamples = []
		roleExamples.push(Master)
		if (adm > 0) {
			roleExamples.push(Administration)
		}
	} else if (decryptedMessage === 'ROLE_ADMIN' || decryptedMessage === 'ROLE_ADMIN_HRD') {
		roleExamples = []
		roleExamples.push(Master)
		if (hrd > 0) {
			roleExamples.push(HumanCapital)
		}
	}

	const myArray = decryptedMessage.split(',')
	for (let i = 0; i < myArray.length; i++) {
	  if (myArray[i] === 'ROLE_TEACHER') {
		Academic.menu = []
		Academic.menu.push(Student)
		Academic.menu.push(Alumni)

		roleExamples = []
		roleExamples.push(Master)
		if (aca > 0) {
			roleExamples.push(Academic)
		}
	  } else if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_ACADEMIC') {
		roleExamples = []
		roleExamples.push(Master)
		if (aca > 0) {
			roleExamples.push(Academic)
		}
	  } else if (myArray[i] === 'ROLE_ADMIN_WEBSITE') {
		roleExamples = []
		roleExamples.push(Master)
		if (wbs > 0) {
			roleExamples.push(Web)
		}
	  } else if (myArray[i] === 'ROLE_PROJECT_MANAGER' || myArray[i] === 'ROLE_PROJECT_SECRETARY') {
		roleExamples = []
		roleExamples.push(Master)
		if (adm > 0) {
			roleExamples.push(Administration)
		}
	  } else if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD') {
		roleExamples = []
		roleExamples.push(Master)
		if (aca > 0) {
			roleExamples.push(HumanCapital)
		}
	  }
	}
}

const menuDocManagement = [
	'General',
	[
		{
			to: '/home',
			icon: mdiViewDashboard,
			label: 'sidebar.dashboard'
		}
	],
	'Examples', roleExamples
]
export default menuDocManagement
